import { FormControl, MenuItem, Box } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "../../../config";
import { updateVideos } from "../../../reduxStore";
import styled from 'styled-components'

export default function SortOptions(props){
    const dispatch = useDispatch()

    const videos = useSelector(state => state.videos)
    const sortOptions = useSelector(state => state.sortOptions)
    // console.log(sortOptions)

    const [selectedSortOption, setSelectedSortOption] = useState(sortOptions[0])

    const handleChange = (e) => {
        console.log(e.target.value)
        setSelectedSortOption(e.target.value)
    }

    const sortVideos = async () => {
        const res = await axios.get(`${endpoint}?sortBy=${selectedSortOption}`)
        dispatch(updateVideos(res.data.videos))
    }

    useEffect(() => {
        sortVideos()
    }, [selectedSortOption])

    return (
        <Box className="sort-options" sx={{margin: '5px'}}>
            <Select
                title="sortOptions"
                name="sortOptions"
                value={selectedSortOption}
                onChange={handleChange}
                className='sort-select'
            >
                {
                    sortOptions.map(sortOption => (
                        <option 
                            value={sortOption}
                            id={sortOption === 'releaseDate' ? 'release-date-option' : sortOption === 'viewCount' ? 'view-count-option' : sortOption}
                            key={sortOption}
                        >
                            {sortOption === 'releaseDate' ? 'Release Date' : 'View Count'}
                        </option>
                    ))
                }
            </Select>
        </Box>
    )
}

const Select = styled.select`   
    padding: 6.5px;
    margin-left: 10px;
    border-radius: 1rem;
`